<template>
    <div
        class="bg-slate-100 w-5/6 h-11/12 lg:h-5/6 lg:w-1/2 rounded-2xl shadow-lg flex flex-col lg:flex-row lg:items-stretch relative">

        <!-- ✅ LOADING SCREEN -->
        <LoadingScreen v-if="loading" :fetchError="fetchError" :fetchErrorMessage="fetchErrorMessage" />
        <transition name="fade">
            <GiftyAppModal v-if="giftyAppModal" :transactionStatus="transactionStatus" @removeModal="hideGitfyAppModal">
            </giftyAppModal>
        </transition>
        <transition name="fade">
            <ConfirmOrderCancelationModal v-if="showCancelOrderConfirmationModal" @CloseCancel="hideCancelModal"
                @ConfirmCancel="confirmCancelation"></ConfirmOrderCancelationModal>
        </transition>
        <transition name="fade">
            <OrderCancelationModal v-if="showOrderCancellationConfirmation"></OrderCancelationModal>
        </transition>
        <!-- ✅ ACTUAL CONTENT -->
        <template v-if="!loading">
            <Form v-if="responseData" :amount="responseData.amount" :redirectUrl="responseData.thank_you_url"
                :keyItem="responseData.key" :isPartial="responseData.is_partial" @showGapp="showGitfyAppModal"
                @hideGapp="hideGitfyAppModal" @transactionRespond="toggleGiftyTransactionCard"
                @showCancelModal="showCancelConfirmationModal" />
            <Summary v-if="responseData" :cart="cart" :store="responseData.store" :service="responseData.service" />

        </template>

    </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";
import { getPurchaseData, cancelOrder } from "../services/api.js"

import Form from "./FormCard.vue";
import Summary from "./SummaryCard.vue";

import LoadingScreen from "./LoadingScreen.vue";

import GiftyAppModal from "./Modals/GiftyAppModal.vue";
import ConfirmOrderCancelationModal from "./Modals/ConfirmOrderCancelationModal.vue";
import OrderCancelationModal from "./Modals/OrderCancelationModal.vue";


const responseData = ref(null);
const loading = ref(true);
const cart = reactive({
    products: [],
    total: 0,
    storeImg: ""
});

const fetchError = ref(false);
const fetchErrorMessage = ref('');
const fetchData = async () => {

    let response;

    const key = window.location.pathname.split('/').pop();
    try {
        response = await getPurchaseData(key);
        console.log('response :>> ', response);
    } catch (error) {
        fetchError.value = true;
        console.log('error :>> ', error);
        fetchErrorMessage.value = JSON.parse(error.request.response).message;

    }

    try {

        responseData.value = response.data;

        cart.total = response.data.amount;
        cart.products = response.data.cart;
        cart.storeImg = response.data.service ? process.env.VUE_APP_DEV_URL + response.data.service.image : '';
        loading.value = false;
    } catch (error) {

        fetchError.value = true;
        console.log('error :>> ', error);
        fetchErrorMessage.value = "Error ";

    }
};


//event and modals 
const giftyAppModal = ref(false);
const showGitfyAppModal = () => {
    giftyAppModal.value = true;
}

const hideGitfyAppModal = () => {
    giftyAppModal.value = false;

}


const transactionStatus = ref(null);

const toggleGiftyTransactionCard = (type) => {
    if (type) {
        //accept
        transactionStatus.value = "accepted"
        giftyAppModal.value = true
        console.log('transactionStatus.value :>> ', transactionStatus.value);
    } else {
        //refuse
        transactionStatus.value = "refused"
        giftyAppModal.value = true
        console.log('transactionStatus.value :>> ', transactionStatus.value);

    }
}

const showCancelOrderConfirmationModal = ref(false);
const showOrderCancellationConfirmation = ref(false);
const showCancelConfirmationModal = () => {
    showCancelOrderConfirmationModal.value = true;
}

const hideCancelModal = () => {
    showCancelOrderConfirmationModal.value = false;
}

const confirmCancelation = async () => {


    try {
        const key = window.location.pathname.split('/').pop();
        let response = await cancelOrder({ key: key });
        console.log('response :>> ', response);
        if (response.data.success) {
            showCancelOrderConfirmationModal.value = false;
            showOrderCancellationConfirmation.value = true;

            setTimeout(() => {
                window.history.back();

            }, 3000);
        }
    } catch (error) {
        console.log('error :>> ', error);
    }

}

onMounted(fetchData);
</script>
<style scoped>
/* Loading transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* Spinner animation */
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.animate-spin {
    animation: spin 1s linear infinite;
}
</style>
